<template>
  <div>
    <v-dialog v-model="helpPushed"  >
      <Help :show2.sync="helpPushed" />
    </v-dialog>
    <v-card style="height: 100%; width: 100%;">
      <v-toolbar dark color="primary">
        <v-btn icon dark @click.native="dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>{{report.name}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark text :class="active == 0 ? 'highlight' : ''" @click.native="active = 0">History (Chart)</v-btn>
        </v-toolbar-items>
          <v-toolbar-items>
          <v-btn dark text :class="active == 1 ? 'highlight' : ''" @click.native="active = 1">History (Table)</v-btn>
        </v-toolbar-items>
          <v-toolbar-items>
          <v-btn dark text :class="active == 2 ? 'highlight' : ''" @click.native="active = 2">Alerts</v-btn>
        </v-toolbar-items>
        <v-toolbar-items v-if="loggedinUser.role === 'super'">
          <v-btn dark text :class="active == 3 ? 'highlight' : ''" @click.native="active = 3">Device Management</v-btn>
        </v-toolbar-items>
        <v-btn icon dark>
          <v-icon @click="helpPage()">help</v-icon>
        </v-btn>
      </v-toolbar>
      <Sensor v-if="active == 0" style="width: 100%; height: 100%" :deviceID="id"></Sensor>
      <!-- <DeviceMgmt v-if="active === 3" style="width: 100%; height: 100%" :id="id"></DeviceMgmt> -->
      <server-table-component v-if="active===1"
        simple
        server="org"
        :rowProp="rows"
        :schemaProp="sch"
        :editable="false"
      ></server-table-component>
    </v-card>
  </div>
</template>


<script>
import { sync } from 'vuex-pathify'
import Sensor from './Sensor'
import Help from './help'
// import DeviceMgmt from '@/../extern/library/DeviceManagement'
// import Table from '@/library/ServerTable'
// import axios from 'axios'
import axiosInstances from '@/../../coreui/server/axiosInstances'
import moment from 'moment'
export default {
  components: {
    Sensor,
    Help,
    // DeviceMgmt,
    // Table
  },
  props: [ 'show', 'id'],
  watch: {
    async active(val, old) {
      console.log('Showing page: ', val)
      switch (val) {
        case 1:
          this.rows = []
          this.tableName = this.id
          let r = await axiosInstances.apiServer.get('/dt/v1/' + this.id)
          if (r.data === undefined ||  r.data.length === 0) return
          r = r.data
          let header = []
          this.headers = [{text: 'Time', value: 'ts', show: true, format:  "type:self;filter:date"}]
          Object.keys(r[0].data).forEach(x => {
            let f = this.dictionary.filter(y => y.code === x)
            this.headers.push({text: f[0].label, value: x, show: true, format:  "type:self;filter:string"})
          })
          
          r.forEach(x => {
            let v = {}
            // console.log(moment(x.ts).format()) 'YYYY/MM/DD HH:mm:ss'
            v['ts'] = moment(x.ts).format('YYYY/MM/DD HH:mm:ss')
            Object.keys(x.data).forEach(y => {
              v[y] = x.data[y].toString()
            })
            this.rows.push(v)
          })
          console.log(this.rows, this.headers)
          this.sch.headers = this.headers
          this.sch.editables = []
      }
    }
  },
  data () {
    return {
      helpPushed: false,
      headers: [],
      rows: [],
      sch: {},
      active: 0,
      report: {
      name: 'Sensor Details',
      rBack: [],
      hBack: [],
      pages: [
        {
          title: 'History',
          component: Sensor
        }, {
          title: 'History',
          // component: Table,
        }, {
          title: 'Notifications'
        }, {
          title: 'Management',
          // component: DeviceMgmt
        }
      ]
    },
    }
  },
  computed: {
    dark: sync('misc/dark'),
    loggedinUser: sync('login/loggedinUser'),
    // rows: sync('tableRows'),
    // headers: sync('tableHeaders'),
    dictionary: sync('table/dictionary'),
    // tableName: sync('tableName'),
    dialog: {
      get: function () { return this.show },
      set: function (val) {
        this.$emit('update:show', val)
      }
    }
  },
  // watch: {
  //   helpPushed(val) {
  //     console.log('helpPushed: ', val)
  //   }
  // },
  methods: {
    helpPage () {
      console.log('help pushed')
      this.helpPushed = true
    }
  },
  mounted () {
    this.active = 0
    // console.log('ID: ',this.id)
  },
  beforeDestroy () {
  }
}
</script>

<style scoped>
.highlight {
  font-weight: bold;
  text-decoration: underline;
  text-underline-position:auto;
}
</style>

